import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnzz29nrxi: FaireProductEntity = {
  token: "p_bnzz29nrxi",
  type: "product",
  name: "Balsam Fir \u2013 34oz Winter Holiday Strong Scented Candle",
  brandName: "A Cheerful Giver",
  imageUrl:
    "https://cdn.faire.com/fastly/39d2bd2acbc2c419b89f83585f878549bc1dc3644638c2e1b4f6eec7cf27774d.jpeg",
  priceDollars: 14,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/01445ab68cd1e9a4c43add01029bc847f5348fd895c09179ee6120ce113642bd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
